<template>
  <page-wrapper :title="title" class="multiple-service-unavailable-date-page">
    <div class="container wrapper">
      <h3 class="mb-4">{{ title }}</h3>
      <div class="row">
        <div class="col-lg-6 mb-4">
          <h4 class="mb-t">ทุก ๆ วันที่</h4>
          <div class="date-calendar">
            <el-checkbox-group v-model="form.unavailableWorkdaysInMonth">
              <el-checkbox-button
                v-for="date in dates"
                :key="date"
                :label="date"
                >{{ date }}</el-checkbox-button
              >
            </el-checkbox-group>
          </div>

          <h4 class="mt-4">ทุก ๆ วัน</h4>
          <div class="day-calendar">
            <el-checkbox-group v-model="form.unavailableWorkdaysInWeek">
              <el-checkbox-button
                v-for="day in days"
                :key="day.value"
                :label="day.value"
                >{{ day.label }}</el-checkbox-button
              >
            </el-checkbox-group>
          </div>

          <h4 class="mt-4">ทุก ๆ ช่วงเวลา</h4>
          <div class="time-calendar">
            <el-checkbox-group v-model="form.unavailableTimes">
              <el-checkbox-button
                v-for="time in times"
                :key="time.value"
                :label="time.value"
                >{{ time.label }}</el-checkbox-button
              >
            </el-checkbox-group>
          </div>

          <h4 class="mt-4">เฉพาะวันที่</h4>
          <date-picker
            :value="selectedDate"
            class="mb-4"
            @input="handleChangeSelectedDate"
          ></date-picker>
          <div
            v-for="(dateTime, index) in unavailableDateTimes"
            :key="dateTime"
            class="mb-4"
          >
            {{ dateTime }}
            <sc-button
              class="btn-remove"
              variant="danger"
              size="sm"
              @click="handleRemove(index)"
              >ลบ</sc-button
            >
          </div>
        </div>
        <div class="col-lg-6 mb-4">
          <service-selector
          v-model="form.services"
          :show-add-all="true"
          class="input"
          ></service-selector>
        </div>
      </div>
      <div class="text-end">
        <sc-button :disabled="disableSubmitButton" variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import DatePicker from "@/lib/components/DatePicker";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import ServiceSelector from "@/lib/components/ServiceSelector/ServiceSelector";
import { toLocaleTH } from "@/lib/dateTime";
import {
  CheckboxButton as ElCheckboxButton,
  CheckboxGroup as ElCheckboxGroup
} from "element-ui";

export default {
  components: {
    PageWrapper,
    ScButton,
    ElCheckboxButton,
    ElCheckboxGroup,
    DatePicker,
    ServiceSelector,
  },
  data() {
    const title = "วันที่ไม่สามารถนัดหมายบริการ";
    const form = {
      unavailableWorkdaysInMonth: [],
      unavailableWorkdaysInWeek: [],
      unavailableDateTimes: [],
      unavailableTimes: [],
      services: []
    };
    const selectedDate = null;
    const dates = Array.from(new Array(31)).map((_, index) => index + 1);
    const days = [
      { label: "วันจันทร์", value: "MONDAY" },
      { label: "วันอังคาร", value: "TUESDAY" },
      { label: "วันพุธ", value: "WEDNESDAY" },
      { label: "วันพฤหัสบดี", value: "THURSDAY" },
      { label: "วันศุกร์", value: "FRIDAY" },
      { label: "วันเสาร์", value: "SATURDAY" },
      { label: "วันอาทิตย์", value: "SUNDAY" }
    ];
    const times = [
      { label: "ช่วงเช้า", value: "MORNING" },
      { label: "ช่วงบ่าย", value: "AFTERNOON"}
    ]
    const disableSubmitButton = false;
    return {
      title,
      form,
      dates,
      days,
      times,
      selectedDate,
      disableSubmitButton,
    };
  },
  computed: {
    unavailableDateTimes() {
      return this.form.unavailableDateTimes
        .map(dateTime => toLocaleTH(dateTime).toFormat("dd MMMM yyyy"));
    }
  },
  watch: {},
  methods: {
    async handleClickSave() {
      const data = {
        ...this.form,
        serviceIds: this.form.services.map(s => s.id),
        unavailableDateTime: this.form.unavailableDateTimes.map(d => d.toISO())
      };
      this.disableSubmitButton = true
      if (data.services.length < 1) {
        this.$message.error("ไม่สามารถบันทึกวันที่ไม่สามารถนัดหมายได้ กรุณาเลือก services");
        this.disableSubmitButton = false
      } else {
        try {
          const requestData = {
            unavailableWorkdaysInMonth: data.unavailableWorkdaysInMonth,
            unavailableWorkdaysInWeek: data.unavailableWorkdaysInWeek,
            unavailableTimes: data.unavailableTimes,
            unavailableDateTimes: data.unavailableDateTime,
            serviceIds: data.serviceIds
          }
          await baanRueJaiClient.admin.subscriptions.services.postServiceWorkdays(requestData);
            this.$message.success("บันทึกเรียบร้อย");
            this.disableSubmitButton = false;
            this.$router.replace({ name: "ServiceListPage" });
        } catch (error) {
          this.$message.error("ไม่สามารถบันทึกวันที่ไม่สามารถนัดหมายได้");
          this.disableSubmitButton = false
        }
      }
    },
    handleRemove(index) {
      this.form.unavailableDateTimes = this.form.unavailableDateTimes.filter(
        (_, i) => i !== index
      );
    },
    handleChangeSelectedDate(date) {
      if (
        this.form.unavailableDateTimes.find(d => d.valueOf() === date.valueOf())
      ) {
        return;
      }

      this.form.unavailableDateTimes.push(date);
      this.form.unavailableDateTimes.sort((a, b) => a.toMillis() - b.toMillis());
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.multiple-service-unavailable-date-page {
  .wrapper {
    padding-top: $space;
    padding-bottom: $space;
  }

  .date-calendar {
    .el-checkbox-group {
      display: grid;
      grid-template-columns: repeat(7, 40px);
      padding: 10px;
    }
  }

  .btn-remove {
    float: right;
  }
}
</style>
